import createAxiosInstance from './axios-instance';
import getSettings from './settings-loader';

const Token = async () => {

    let account = sessionStorage.getItem('account');

    if (!account)
        account = localStorage.getItem('account');

    return account ? JSON.parse(account).token : '';
};

const getToken = async (phone, password) => {

    const axiosOptions = {
        headers: {
            'phone': phone, 'password': password
        }
    };

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get('/v1/getAuth');

};

const getTasksCount = async () => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get('/v1/getTasksCount');

};

const getTasks = async (skip, take, isCompactMode, color, searchText) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/selTasks?rowIndex=" + skip;
    url += "&rowCount=" + take;
    url += "&color=" + color;
    url += "&isCompactMode=" + isCompactMode;

    if (searchText) {
        url += "&searchText=" + searchText;
    }

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);

};


const postTasksComplete = async (IDs) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.post("/v1/updTasksIsComplete", { taskIDs: IDs });

};

const getTask = async (id) => {

    // const axiosOptions = {
    //     headers: {
    //         'Authorization': await Token()
    //     }
    // };

    // let url = "/v1/getTask?id=" + id;

    // // Create a new instance of Axios with the desired context
    // const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    // return axiosInstanceWithOptions.get(url);

    const token = await Token();

    if (!token)
        return null;

    const settings = await getSettings();

    const { apiUrl } = settings[window.location.hostname];

    try {

        const response = await fetch(apiUrl + "/v1/getTask?id=" + id, {
            headers: {
                'Authorization': token
            }
        });

        if (!response.ok) {
            throw new Error('Object not found');
        }

        const data = await response.json();
        return data; // Return the retrieved object
    }
    catch (error) {
        return null;
    }


};

const getFile = async (id) => {

    const token = await Token();

    if (!token)
        return null;

    const settings = await getSettings();

    const { apiUrl } = settings[window.location.hostname];

    return fetch(apiUrl + "/v1/getFile?fileID=" + id, {
        headers: {
            'Authorization': token
        }

    })
        .then(response => response.body.getReader())
        .then(reader => {
            var arr = [];
            //label.innerHTML += `Request successful.<br><br>Reading request body at ${new Date()}.<br><br>`;
            return reader.read().then(function processData(result) {

                if (result.done) {

                    return reader.closed.then(function () {

                        return arr;
                    });
                };

                var i, len = arr.length;

                for (i = 0; i < result.value.length; i++)
                    arr[len + i] = result.value[i];

                //output.innerHTML = ` ${json.length} of ${progress.max} bytes read`;
                //progress.value = json.length;

                return reader.read().then(processData)
            })

        }, (error) => {

            throw new Error(error);

        })
}

const postCommandResult = async (taskID, commandID) => {

    const token = await Token();

    if (!token)
        return null;


    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.post("/v1/insCommandResult", { commandID: commandID, taskID: taskID });
};

const getAccounts = async (clienID) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/selAccounts?clientID=" + clienID;

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);
};

const getMessages = async (recipientID, skip, take, searchText) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/selMessages?recipientID=" + recipientID;
    url += "&rowIndex=" + skip;
    url += "&rowCount=" + take;

    if (searchText) {
        url += "&searchText=" + searchText;
    }

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);

};



const postMessage = async (text, recipientID) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.post("/v1/insMessage", { text: text, recipientID: recipientID });
};


const postIsRead = async (IDs) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.post("/v1/updMessagesRead", { IDs: IDs });
};

const getMemberships = async () => {

    const token = await Token();

    if (!token)
        return null;


    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/selMemberships";

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);
};

const getTasksAll = async () => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v2/selTasks";

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);

};

const getAccount = async (id) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/getAccount?id=" + id;

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);
};

const getForm = async (id, taskID) => {

    const token = await Token();

    if (!token)
        return null;

    const axiosOptions = {
        headers: {
            'Authorization': token
        }
    };

    let url = "/v1/getForm?id=" + id;

    if (taskID){
        url+= "&taskID=" + taskID;
    }

    // Create a new instance of Axios with the desired context
    const axiosInstanceWithOptions = await createAxiosInstance(axiosOptions);

    return axiosInstanceWithOptions.get(url);
};

export {
    getToken,
    getTasksCount,
    getTasks,
    postTasksComplete,
    getTask, 
    getFile, 
    postCommandResult, 
    getAccounts, 
    getMessages, 
    postMessage, 
    postIsRead, 
    getMemberships, 
    getTasksAll, 
    getAccount,
    getForm
};